export enum LocalStorageKey {
  SessionToken = 'BTLNet.SessionToken',
  LastLoggedUserEmail = 'BTLNet.LastLoggedUserEmail',
  DocumentsViewMode = 'BTLNet.DocumentsViewMode',
  EventsViewMode = 'BTLNet.EventsViewMode'
}

export type DocumentsViewMode = 'list' | 'grid';
export type EventsViewMode = 'calendar' | 'list';
